import { render, staticRenderFns } from "./emoji_group.vue?vue&type=template&id=77632127"
import script from "./emoji_group.vue?vue&type=script&lang=js"
export * from "./emoji_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports